import { Mutation } from 'vuex';
import { IModuleState } from './types';

export const setImgColor: Mutation<IModuleState> = (state, payload) => {
  state.imgcolor.data = payload.data;
  state.imgcolor.loading = !!payload.loading;
};

export const setParams: Mutation<IModuleState> = (state, payload) => {
  state.params.imgKey = payload.imgKey;
  state.params.colors = payload.colors;
  state.params.brightAdjust = payload.brightAdjust;
  state.params.saturationAdjust = payload.saturationAdjust;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
